export default class NotificationsRuleCtrl {

	constructor($scope, $state, $stateParams, GeneralSettingsSrv, GlobalConfig) {
		var notificationRuleVm = this

		notificationRuleVm.config = GlobalConfig
		notificationRuleVm.isSaveButtonDisabled = false
		notificationRuleVm.minDate = new Date()

		notificationRuleVm.notification = {}
		notificationRuleVm.notification.shipping_time = 'dependent'
		notificationRuleVm.notification.roles = {}
		notificationRuleVm.notification.days = {}
		notificationRuleVm.notification.daysBefore = {
			1: false,
			2: false,
			5: false,
		}
		notificationRuleVm.notification.deliveryTypes = {}
		notificationRuleVm.notification.specific_date = null

		notificationRuleVm.stages = []
		notificationRuleVm.academicUnits = []
		notificationRuleVm.roles = []
		notificationRuleVm.activities = []
		notificationRuleVm.deliveryTypes = []
		notificationRuleVm.templates = []
		notificationRuleVm.weekdays = [ 'lunes', 'martes', 'miercoles', 'jueves', 'viernes' ]
		notificationRuleVm.isLibre = false

		// VM methods
		notificationRuleVm.hasError = hasError
		notificationRuleVm.showErrorMessages = showErrorMessages
		notificationRuleVm.getFormAttribute = getFormAttribute
		notificationRuleVm.changedSpecificDateCheck = changedSpecificDateCheck
		notificationRuleVm.changedCheckNDaysBefore = changedCheckNDaysBefore
		notificationRuleVm.isRoleEmpty = isRoleEmpty
		notificationRuleVm.isDeliveryTypeEmpty = isDeliveryTypeEmpty
		notificationRuleVm.isDaysEmpty = isDaysEmpty
		notificationRuleVm.isRequiredEventDependent = isRequiredEventDependent
		notificationRuleVm.validateForm = validateForm
		notificationRuleVm.saveNotification = saveNotification
		notificationRuleVm.changeTemplate = changeTemplate
		notificationRuleVm.isSubjectEmpty = isSubjectEmpty
		notificationRuleVm.checkIsLibre = checkIsLibre

		activate()

		function activate() {
			if ($stateParams.notificationId)
				return getFormData().then(
					getNotification($stateParams.notificationId).then(() => {}),
				)

			return getFormData().then(() => {})
		}

		function hasError(input) {
			if (input.$invalid && (input.$dirty || input.$touched))
				return 'has-error'
		}

		function showErrorMessages(input) {
			return input.$dirty || input.$touched
		}

		function getFormAttribute(form, attr, index) {
			attr = attr + index

			return form[attr]
		}

		function getFormData() {
			return GeneralSettingsSrv.getAllDataNotificationRules.getList().$promise.then(function(dataReturn) {
				if (dataReturn.status == true) {
					// notificationRuleVm.stages = ( dataReturn.stages )? dataReturn.stages : []
					// notificationRuleVm.academicUnits = ( dataReturn.academic_units )? dataReturn.academic_units : []

					notificationRuleVm.roles = (dataReturn.role) ? dataReturn.role : []

					if (!notificationRuleVm.notification.roles) {
						notificationRuleVm.roles.forEach((role) => {
							notificationRuleVm.notification.roles[ role.id_code ] = false
						})
					}

					// notificationRuleVm.activities = ( dataReturn.submodules )? dataReturn.submodules : []
					notificationRuleVm.deliveryTypes = (dataReturn.delivery_type) ? dataReturn.delivery_type : []

					if (!notificationRuleVm.notification.deliveryTypes) {  
						notificationRuleVm.deliveryTypes.forEach((deliveryType) => {
							notificationRuleVm.notification.deliveryTypes[ deliveryType.id_code ] = false
						})
					} else {
						notificationRuleVm.notification.deliveryTypes[ notificationRuleVm.deliveryTypes[0].id_code ] = true
					}

					notificationRuleVm.templates = (dataReturn.templates) ? dataReturn.templates : []
				} else {
					notificationRuleVm.stages = []
				}

				notificationRuleVm.notificationType = (dataReturn.notification_type) ? dataReturn.notification_type : []
			}, function(data) {
				console.log(data)
			})
		}

		function getNotification(notificationId) {
			return GeneralSettingsSrv.getNotificationById.get({ notificationId: notificationId }).$promise.then(function(dataReturn) {
				if (dataReturn.status == true) {
					if (dataReturn.data) {
						if (!dataReturn.data[0] || dataReturn.data[0].id_create_notification_type != 1)
							$state.go('generalSettings.notificationsManagement')

						notificationRuleVm.notification = formatNotificationIn(dataReturn.data[0])
					}
				}
			}, function(data) {
				console.log(data)
			})
		}

		function changedSpecificDateCheck(checked) {
			if (!checked)
				notificationRuleVm.notification.specific_date = null
		}

		function changedCheckNDaysBefore(checked) {
			if (!checked)
				notificationRuleVm.nDaysBefore = null
		}

		function isRoleEmpty() {
			for (let role in notificationRuleVm.notification.roles) {
				if (notificationRuleVm.notification.roles[ role ])
					return false
			}

			return true
		}

		function isDeliveryTypeEmpty() {
			for (let deliveryType in notificationRuleVm.notification.deliveryTypes) {
				if (notificationRuleVm.notification.deliveryTypes[ deliveryType ])
					return false
			}

			return true
		}

		function isSubjectEmpty() {
			if (notificationRuleVm.notification.asunto) {
				return false
			}

			return true
		}

		function isDaysEmpty() {
			for (let day in notificationRuleVm.notification.days) {
				if (notificationRuleVm.notification.days[ day ])
					return false
			}

			return true
		}

		function isRequiredEventDependent() {
			return notificationRuleVm.notification.shipping_time == 'dependent' &&
				!(
					notificationRuleVm.notification.is_at_sending_moment ||
					!isDaysBeforeEmpty() ||
					notificationRuleVm.nDaysBefore ||
					notificationRuleVm.notification.specific_date
				)
		}

		function isDaysBeforeEmpty() {
			for (let day in notificationRuleVm.notification.daysBefore) {
				if (notificationRuleVm.notification.daysBefore[ day ])
					return false
			}

			return true
		}

		function validateForm(form) {
			return form.$invalid
		}

		function saveNotification() {
			notificationRuleVm.isSaveButtonDisabled = true
			let notification = formatNotification(notificationRuleVm.notification)

			// console.log('......',notification);
			if ($stateParams.notificationId)
				editNotification(notification)
			else
				createNotification(notification)
		}

		function createNotification(notification) {
			GeneralSettingsSrv.createNotificationRule.save(notification).$promise.then((dataReturn) => {
				if (dataReturn.status == true) {
					$state.go('generalSettings.notificationsManagement')
				} else {
					notificationRuleVm.isSaveButtonDisabled = false
					console.log('Comunications problem with the server')
				}
			}, (data) => {
				console.log(data)
			})
		}

		function editNotification(notification) {
			notification.id_notification = notification.id_code
			GeneralSettingsSrv.updateNotification.save(notification).$promise.then((dataReturn) => {
				if (dataReturn.status == true) {
					$state.go('generalSettings.notificationsManagement')
				} else {
					notificationRuleVm.isSaveButtonDisabled = false
					console.log('Comunications problem with the server')
				}
			}, (data) => {
				console.log(data)
			})
		}

		function changeTemplate(selectedTemplate) { 
			notificationRuleVm.notification.ds_description = selectedTemplate.ds_description
		}

		function formatNotificationIn (notification) {
			notification.roles = {}
			notification.daysBefore = {}
			notification.deliveryTypes = {}
			notification.days = {}

			if (notification.specific_date) {
				let m = moment(notification.specific_date, 'YYYY-MM-DD')

				notification.specific_date = m.isValid() ? m.toDate() : null
				notificationRuleVm.specific_date_check = true
			} else {
				notification.specific_date = null
			}

			if (notification.id_role) {
				let rolesArray = []

				rolesArray = notification.id_role.split(',')
				rolesArray = rolesArray.map((roleId) => parseInt(roleId))
				rolesArray.forEach(rol => notification.roles[ rol ] = true)
			}

			if (notification.id_notification_delivery_type) { 
				let deliveryTypesArray = []

				notification.deliveryTypes = {}
				deliveryTypesArray = notification.id_notification_delivery_type.split(',')

				deliveryTypesArray = deliveryTypesArray.map((deliveryTypeId) => parseInt(deliveryTypeId))
				deliveryTypesArray.forEach(deliveryTypeId => notification.deliveryTypes[ deliveryTypeId ] = true)
			}

			if (notification.id_schedule_notification_type == 3) {
				notification.shipping_time = 'dependent'

				if (notification.ds_days_before) {
					let daysBeforeArray = notification.ds_days_before.split(',')

					daysBeforeArray = daysBeforeArray.map((day) => parseInt(day))
					notificationRuleVm.nDaysBefore = daysBeforeArray.find(day => ![ 1, 2, 5 ].includes(day))

					if (notificationRuleVm.nDaysBefore) {
						notificationRuleVm.checkNDaysBefore = true
						let index = daysBeforeArray.indexOf(notificationRuleVm.nDaysBefore)

						if (index != -1)
							daysBeforeArray.splice(index, 1)
					}

					daysBeforeArray.forEach(day => notification.daysBefore[ day ] = true)
				}
			} else if (notification.id_schedule_notification_type === 2) {
				notification.shipping_time = 'weekly'

				if (notification.ds_days) {
					let daysArray = notification.ds_days.split(',')

					daysArray = daysArray.map((day) => parseInt(day))
					daysArray.forEach(day => notification.days[ day ] = true)
				}
			}

			return notification
		}

		var formatNotification = function(notification) {
			notification.id_create_notification_type = 1
			// notification.ds_name =""

			let rolesArray = []

			for (let role in notification.roles) {
				if (notification.roles[ role ])
					rolesArray.push(role)
			}

			notification.id_role = rolesArray.join(',')

			let deliveryTypesArray = []

			for (let deliveryType in notification.deliveryTypes) {
				if (notification.deliveryTypes[ deliveryType ])
					deliveryTypesArray.push(deliveryType)
			}

			notification.id_notification_delivery_type = deliveryTypesArray.join(',')

			notification.id_template = (notificationRuleVm.selectedTemplate) ? notificationRuleVm.selectedTemplate.id_code : null

			if (notification.shipping_time == 'dependent') {
				notification.id_schedule_notification_type = 3
				notification.ds_days = ''

				let daysBeforeArray = []

				for (let day in notification.daysBefore) {
					if (notification.daysBefore[ day ])
						daysBeforeArray.push(parseInt(day))
				}

				if (notificationRuleVm.checkNDaysBefore &&
					notificationRuleVm.nDaysBefore &&
					!daysBeforeArray.includes(notificationRuleVm.nDaysBefore)) {
					daysBeforeArray.push(notificationRuleVm.nDaysBefore)
				}

				notification.ds_days_before = daysBeforeArray.join(',')

				if (notification.specific_date) {
					notification.specific_date = moment(notification.specific_date).format('YYYY-MM-DD hh:mm:ss')
				}
			} else if (notification.shipping_time == 'weekly') {
				notification.id_schedule_notification_type = 2
				notification.ds_days_before = ''
				notification.specific_date = ''
				notification.is_at_sending_moment = ''
				let daysArray = []

				for (let day in notification.days) {
					if (notification.days[ day ])
						daysArray.push(parseInt(day))
				}

				notification.ds_days = daysArray.join(',')
			}

			return notification
		}

		function checkIsLibre() {
			if (notificationRuleVm.config.notificationTypeLibre.libre === notificationRuleVm.notification.id_notificationType) {
				notificationRuleVm.isLibre = true
			} else {
				notificationRuleVm.isLibre = false
			}
		}
	}//FIN DEL CONSTRUCTOR

	preventInput(event) {
		var vKey = 86

		if (event.keyCode == vKey)
			event.preventDefault()

		return     
	}

}

NotificationsRuleCtrl.$inject = [ '$scope', '$state', '$stateParams', 'GeneralSettingsSrv', 'GlobalConfig' ]



// WEBPACK FOOTER //
// ./src/app/u-faculty/generalSettings/notifications/rules/notificationRuleCtrl.js